import styled from "styled-components";

export const TextInputWrapper = styled.input`
  background: rgba(255, 255, 255, 0.05);
  border-radius: 1px;
  height: 48px;
  outline: none;
  border: none;
  color: #ffffff;
  width: 100%;
  padding: 0 16px;
  font-size: 16px;
  border: 1px solid transparent;

  &.error {
    border: 1px solid crimson;
  }
`;
